import { USER_STATUSES } from "../../../constants/constants";
import { USER_ROLES_DICTIONARY } from "../../../dictionaries";
import { renderRecordValue } from "../../../utils";
import styles from './index.module.css';

const USER_STATUS_LABELS = {
    [USER_STATUSES.INVITED]: 'Invited (Pending Activation)',
    [USER_STATUSES.EXPIRED]: 'Invite Expired',
    [USER_STATUSES.DISABLED]: 'Inactive',
    [USER_STATUSES.ACTIVE]: 'Active',
};

export const transformMultiSiteData = ({ data, Navigation }) => {
    return data?.map((value) => {
        return {
            key: value.id,
            name:
                value.firstName &&
                value.lastName &&
                renderRecordValue(`${value.firstName} ${value.lastName}`),
            email: value.email,
            type: value.role,
            status: USER_STATUS_LABELS[value.status] || value.status,
            organization_name: value.organization_name
        };
    });
};

export const MultiSiteCols = () => [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: (text) => (<div className={styles.cellValue, styles.semiBold}>{renderRecordValue(text)}</div>),
        width: 350,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 150,
        render: (text) => <div className={styles.cellValue}>{text}</div>,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        width: '20%',
        render: (text) => (<div className={styles.cellValue}>{text}</div>),
    },
    {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        width: '15%',
        render: (text) => <div className={styles.cellValue, styles.semiBold}>{USER_ROLES_DICTIONARY[text]}</div>,
    },
    {
        title: 'Parent Organization',
        dataIndex: 'organization_name',
        key: 'organization_name',
        width: '30%',
        render: (text) => <div className={styles.cellValue, styles.rootOrg}>{text}</div>,
    },
    // {
    //   title: '',
    //   width: 200,
    // },
]